import Head from 'next/head';
import Forms from '@/components/Forms';

const Page = () => {
  return (
    <>
      <Head>
        <title>Formulare</title>
      </Head>
      <Forms />
    </>
  );
};

export default Page;
